'use strict';

angular.module('msCore').controller('logoutCtrl', logoutCtrl);

logoutCtrl.$inject = ['userSvc', 'msAuth', 'windowSvc'];

function logoutCtrl(userSvc, msAuth, windowSvc) {
  var vm = this;
  vm.$onInit = _init;

  ////////////////

  function _init() {
    // Call logout endpoint then remove cookie and redirect
    userSvc.logout().then(function () {
      _removeCookieAndRedirect();
    }, function () {
      _removeCookieAndRedirect();
    });
  }

  function _removeCookieAndRedirect() {
    msAuth.logout();
    if (!msAuth.ssoLogout()) {
      windowSvc.windowNavigate('/login');
    }
  }
}